<template>
  <transition name="sheet">
    <div v-if="show" class="sheet-layer">
      <div class="scrim" @click="close" @touchmove.prevent />
      <section class="sheet" role="dialog" aria-modal="true" :aria-label="title">
        <div class="sheet-grab" />
        <header class="sheet-head">
          <div>
            <h2>{{ title }}</h2>
            <p>{{ summary }}</p>
          </div>
          <button type="button" class="sheet-close" @click="close">收起</button>
        </header>
        <div v-if="quick" class="quick-days">
          <button v-for="item in quickDays" :key="item.label" type="button" class="chip" :class="{ active: item.date === day }" @click="setDay(item.date)">
            {{ item.label }}
          </button>
        </div>
        <div class="cal-head">
          <button type="button" class="cal-nav" aria-label="上个月" @click="shift(-1)">
            <app-icon name="back" />
          </button>
          <strong>{{ viewYear }} 年 {{ viewMonth + 1 }} 月</strong>
          <button type="button" class="cal-nav" aria-label="下个月" @click="shift(1)">
            <app-icon name="arrow" />
          </button>
        </div>
        <div class="cal-week">
          <span v-for="name in weekNames" :key="name">{{ name }}</span>
        </div>
        <div class="cal-grid">
          <button v-for="cell in cells" :key="cell.date" type="button" class="cal-day" :class="{ muted: !cell.inMonth, today: cell.date === todayText, on: cell.date === day }" :disabled="!!min && cell.date < min" @click="setDay(cell.date)">
            {{ cell.day }}
          </button>
        </div>
        <template v-if="withTime">
          <div class="time-head">
            <span>时间</span>
            <div class="seg">
              <button v-for="item in minutes" :key="item" type="button" :class="{ on: item === minute }" @click="minute = item">
                :{{ item }}
              </button>
            </div>
          </div>
          <div class="time-grid">
            <button v-for="item in hours" :key="item" type="button" :class="{ on: item === hour }" @click="hour = item">
              {{ item }}:{{ minute }}
            </button>
          </div>
        </template>
        <div class="sheet-foot" :class="{ two: clearable }">
          <button v-if="clearable" type="button" class="button outline" @click="clear">清除</button>
          <button type="button" class="button" :disabled="!day" @click="confirm">确定</button>
        </div>
      </section>
    </div>
  </transition>
</template>
<script>
import { today, parseDay, dayString, addDays, dateTimeText } from '../common/when'
const hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21']
export default {
  props: {
    show: Boolean,
    title: { type: String, default: '选择日期' },
    // YYYY-MM-DD 或 YYYY-MM-DDTHH:mm
    value: { type: String, default: '' },
    withTime: Boolean,
    clearable: Boolean,
    min: { type: String, default: '' },
    quick: Boolean
  },
  data() {
    const now = new Date()
    return {
      day: '',
      hour: '10',
      minute: '00',
      viewYear: now.getFullYear(),
      viewMonth: now.getMonth(),
      weekNames: ['一', '二', '三', '四', '五', '六', '日'],
      todayText: today()
    }
  },
  computed: {
    hours() {
      return hours.indexOf(this.hour) >= 0 ? hours : hours.concat(this.hour).sort()
    },
    minutes() {
      return ['00', '30'].indexOf(this.minute) >= 0 ? ['00', '30'] : ['00', '30', this.minute].sort()
    },
    quickDays() {
      const base = this.todayText
      return [
        { label: '今天', date: base },
        { label: '明天', date: addDays(base, 1) },
        { label: '3 天后', date: addDays(base, 3) },
        { label: '一周后', date: addDays(base, 7) }
      ].filter(item => !this.min || item.date >= this.min)
    },
    cells() {
      const first = new Date(this.viewYear, this.viewMonth, 1)
      const start = new Date(first)
      start.setDate(1 - ((first.getDay() + 6) % 7))
      const cells = []
      for (let i = 0; i < 42; i++) {
        const date = new Date(start)
        date.setDate(start.getDate() + i)
        cells.push({ date: dayString(date), day: date.getDate(), inMonth: date.getMonth() === this.viewMonth })
      }
      return cells
    },
    summary() {
      if (!this.day) return '还没有选择日期'
      return dateTimeText(this.withTime ? this.day + ' ' + this.hour + ':' + this.minute : this.day)
    }
  },
  watch: {
    show(value) {
      document.body.classList.toggle('modal-open', value)
      if (value) this.init()
    }
  },
  beforeDestroy() {
    if (this.show) document.body.classList.remove('modal-open')
  },
  methods: {
    init() {
      this.todayText = today()
      const text = String(this.value || '')
      const date = parseDay(text)
      this.day = date ? dayString(date) : ''
      const time = /[ T](\d{2}):(\d{2})/.exec(text)
      this.hour = time ? time[1] : '10'
      this.minute = time ? time[2] : '00'
      const view = date || parseDay(this.min) || new Date()
      this.viewYear = view.getFullYear()
      this.viewMonth = view.getMonth()
    },
    setDay(date) {
      this.day = date
      const view = parseDay(date)
      this.viewYear = view.getFullYear()
      this.viewMonth = view.getMonth()
    },
    shift(step) {
      const view = new Date(this.viewYear, this.viewMonth + step, 1)
      this.viewYear = view.getFullYear()
      this.viewMonth = view.getMonth()
    },
    confirm() {
      if (!this.day) return
      this.$emit('input', this.withTime ? this.day + 'T' + this.hour + ':' + this.minute : this.day)
      this.close()
    },
    clear() {
      this.$emit('input', '')
      this.close()
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datetime-sheet.vue